import React from "react";
import styles from "./Newsletter.module.scss";
import NewsLetterTable from "../../Tables/NewsletterTable/NewsLetterTable";
import NewsletterModal from "./NewsletterModal/NewsletterModal";
import CustomButton from "../../CustomButton/CustomButton";
import { useTranslation } from "react-i18next";

const Newsletter = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = React.useState(false);
  return (
    <div className={styles.newsletter}>
      <div className={styles.newsletterHeader}>
        <CustomButton
          blue
          plus
          width="200px"
          onClick={() => setModalOpen(true)}
        >
          {t("newsletter.addNewsletterButton")}
        </CustomButton>
      </div>
      <NewsLetterTable />
      {modalOpen && <NewsletterModal setModalOpen={setModalOpen} />}
    </div>
  );
};

export default Newsletter;
